import React, { useEffect, useState } from 'react';

const LiveClock = () => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000); // Update every second

    return () => clearInterval(timer); // Cleanup on unmount
  }, []);

  const formatTime = (date) => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = date.toLocaleString('en-US', { month: 'short' }); // Aug
    const year = date.getFullYear();
    const time = date.toLocaleTimeString('en-GB'); // 16:43:38 (24-hour)

    return `${day} ${month}, ${year} | ${time}`;
  };

  return <div>{formatTime(currentTime)}</div>;
};

export default LiveClock;
